import React, { Component, forwardRef } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { search_calender_action, block_calender_action } from '../../actions/calender_actions/calender_action';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { cityActionId, centerActionId, timeSlotActionId, ClientActionId, toastError, toastSuccess } from '../../utils/constants'
import Modal from 'react-bootstrap/Modal';
import { fill_action } from '../../actions/fillList_action';
import $ from 'jquery'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Navigate } from 'react-router-dom';
// import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
import Select from 'react-select';
import moment from 'moment';
import Header from '../../common_components/Header';
import SiteMaintenance from '../../common_components/siteMaintenance';

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderColor: '#80bdff', // Blue border color
        boxShadow: 'none',
        '&:hover': {
            borderColor: '#80bdff', // Blue border color on hover
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        borderRadius: '4px',
        padding: 'none',
        backgroundColor: '#35B3E6', // Blue background color for selected value
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: 'white', // Text color for selected value
        fontSize: '12px'
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: 'white',
        '&:hover': {
            backgroundColor: '#00BCD4',
            color: '#fff' // Blue border color on hover
        }, // Remove icon color for selected value
    }),
};

const ExampleCustomInput = forwardRef(({ value, onClick, onChange, disabled }, ref) => (
    <input
        value={value}
        className="example-custom-input"
        onClick={onClick}
        onChange={onChange}
        disabled={disabled}
        ref={ref}
    ></input>
));


class NormalView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
            isSiteMaintenance: false,
            isLoading: false,
            isOpen2: false,
            isDatesOverFlow: null,
            newDate: '',
            bookingList: [],
            calenderList: [],
            dateList: [],
            centerList: [],
            cityId: '',
            cityList: [],
            clientList: [],
            clientID: '',
            venueId: '',
            venueList: [],
            bookingDate: '',
            timeSlot: [],
            timeSlotList: [],
            tempClientList: [],
            isDisplayClientList: false,

            finalList: [],
            finalDateList: [],
            userID: '',
            selectedCenter: '',
            selectedIDList: [],
            timeSlotIDList: [],
            BlockCalenderList: [],
            holidayArr: [],
            OrderID: '',
            blockedList: [],
            validationList: [],
            validationDateList: [],
            duplicateFinalList: [],
            clientName: '',
            isEdit: 0,
        }
        this.getCalender = this.getCalender.bind(this)
        this.nextWeek = this.nextWeek.bind(this)
        this.prevWeek = this.prevWeek.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.onSelect = this.onSelect.bind(this)
        this.updateSearch = this.updateSearch.bind(this)
        this.createFinalList = this.createFinalList.bind(this)
        this.openCalenderView = this.openCalenderView.bind(this)
        this.onBook = this.onBook.bind(this)
        this.clearSearch = this.clearSearch.bind(this)
        this.clearSelected = this.clearSelected.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.onClientSelect = this.onClientSelect.bind(this)
        this.toggleModal2 = this.toggleModal2.bind(this)
        this.dateCheck = this.dateCheck.bind(this)
        this.handleBlockCalender = this.handleBlockCalender.bind(this)
        this.renderClientList = this.renderClientList.bind(this)
        this.onClientSearch = this.onClientSearch.bind(this)
        this.renderSlots = this.renderSlots.bind(this)

    }

    componentDidMount() {
        // console.log(this.props.params.id)
        const { userID, selectedIDList, selectedCenter, BlockCalenderList } = this.state
        if (JSON.parse(sessionStorage.getItem('bookArray')) != null) {
            var list = []
            JSON.parse(sessionStorage.getItem('bookArray')).map((data) => (selectedIDList.push(data.CalendarID)))
            JSON.parse(sessionStorage.getItem('bookArray')).map((data) => (BlockCalenderList.push({
                'calendarID': parseInt(data.CalendarID),
                'clientID': null,
                'timeslotID': data.TimeslotID
            })))
            // console.log("comp block", JSON.parse(sessionStorage.getItem('bookArray')), BlockCalenderList)
            this.setState({ selectedCenter: JSON.parse(sessionStorage.getItem('bookArray'))[0].CenterID })
            this.setState({ bookingList: JSON.parse(sessionStorage.getItem('bookArray')) })
            JSON.parse(sessionStorage.getItem('bookArray')).map(data => {
                list.push(data.Date)
            })
            this.dateCheck(list)
        }
        if (JSON.parse(sessionStorage.getItem('Is_modify')) == true) {
            this.setState({ isEdit: 1 })
            this.setState({ OrderID: JSON.parse(sessionStorage.getItem('OrderID')) })
            this.setState({ venueId: JSON.parse(sessionStorage.getItem('centerID')) })
        }
        sessionStorage.removeItem('newbookArray')
        var centerIDarr = []
        var centerCodeArr = []
        this.getFillList(cityActionId, userID).then(res1 => {
            res1 && this.getFillList(centerActionId, userID).then(res2 => {
                res2 && this.getFillList(timeSlotActionId, userID).then(res3 => {
                    res3 && this.getFillList(ClientActionId, userID).then(res4 => {
                        this.setState({ isLoading: true })
                        res4 && this.state.venueList.length > 0 &&
                            this.state.venueList.map((item => {
                                centerIDarr.push(item.CenterID)
                                centerCodeArr.push(item.Code)
                            }))
                        res4 && centerCodeArr.includes(this.props.params.id) ?
                            this.state.venueList.map((item => {
                                this.props.params.id == item.Code &&
                                    this.setState({ venueId: item.CenterID })
                            })) :
                            centerIDarr.includes(parseInt(this.props.params.id)) ?
                                this.state.venueList.map((item2 => {
                                    this.props.params.id == item2.Code &&
                                        this.setState({ venueId: parseInt(this.props.params.id) })
                                })) :
                                this.props.params.id != undefined && this.props.navigate('/normalView')
                        res4 && setTimeout(() => {
                            this.getCalender()
                            // this.setState({ isLoading: false })
                        }, 200);
                    })
                })
            })
        })
    }

    toggleModal2() {
        const { isOpen2 } = this.state
        this.setState({ isOpen2: !isOpen2 })
    }

    dateCheck(dateList) {
        var res
        var index
        var today = new Date()
        for (var i = 0; i < dateList.length; i++) {
            dateList[i] = moment(`${dateList[i]}`, 'DD-MM-YYYY')
            dateList[i] = new Date(dateList[i].format('YYYY-MM-DD'))
            var diff = Math.floor((dateList[i].getTime() - today.getTime()))
            if (i == 0) {
                res = diff
                index = 0
            }
            else {
                if (res > diff) {
                    res = diff
                    index = i
                }
            }
        }
        var latDate = moment(dateList[index]).format('L')
        this.setState({ newDate: latDate })
        // console.log(`${latDate}`)
    }

    getFillList(value, userID) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(value, (userID == '' || userID == null) ? null : userID)
                .then((data) => {
                    if (data.error != 1) {
                        if (value == cityActionId) {
                            // console.log(data.data)
                            this.setState({ cityList: data.data, isLoading: false })
                            resolve(true)
                        }
                        if (value == centerActionId) {
                            var list = []
                            for (var i = 0; i < data.data.length; i++) {
                                if (
                                    // data.data[i].ParentCenterID == 0 || data.data[i].ParentCenterID == null
                                    data.data[i].CenterID != 3 && data.data[i].CenterID != 4
                                ) {
                                    list.push(data.data[i])
                                }
                            }
                            // console.log(list)

                            this.setState({ venueList: list, isLoading: false })
                            resolve(true)
                        }
                        if (value == timeSlotActionId) {
                            var timeARR = []
                            // console.log(data)
                            data.data.map(element => {
                                if (element.TimeSlotID == 4) {
                                    element.Name = `${element.Name} (SWASTIKA)`
                                }
                            })
                            for (var i = 0; i < data.data.length; i++) {
                                var timeOBJ = {}
                                if (data.data[i].TimeSlotID != 4) {
                                    // timeOBJ.label = `${data.data[i].FromTime} - ${data.data[i].ToTime}`
                                    timeOBJ.value = data.data[i].TimeSlotID
                                    timeOBJ.label = data.data[i].Name
                                    timeARR.push(timeOBJ)
                                }
                            }
                            this.setState({ timeSlotList: timeARR, isLoading: false })
                            resolve(true)
                        }
                        if (value == ClientActionId) {
                            this.setState({ clientList: data.data, tempClientList: data.data, isLoading: false })
                            resolve(true)
                        }
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })

    }

    selectValidation(id, type) {
        const { selectedCenter, finalList, timeSlotIDList, duplicateFinalList, isDatesOverFlow, selectedIDList, validationDateList, validationList, BlockCalenderList, bookingList, calenderList } = this.state
        var obj = {}
        var err = false
        // var validationDateList = []
        var currentDate
        var validObj
        // var ifDateCanBeRemoved = false
        var toBeTrue = []
        var toBeFalse = []
        var list
        if (timeSlotIDList != '' && timeSlotIDList != null) {
            list = duplicateFinalList
        }
        else {
            list = finalList
        }

        // var dumArr = validationList
        if (validationList.length > 0) {
            for (var a = 0; a < validationList.length; a++) {
                if (!validationDateList.includes(validationList[a].day)) {
                    validationDateList.push(validationList[a].day)
                }
            }
        }
        for (var a = 0; a < list.length; a++) {
            for (var b = 0; b < list[a].days.length; b++) {
                for (var c = 0; c < list[a].days[b].eventListChild.length; c++) {
                    // console.log(list[a].days[b])
                    if (parseInt(id) == list[a].days[b].eventListChild[c].ID) {
                        currentDate = list[a].days[b].day
                        validObj = list[a].days[b]
                    }
                }
                for (var c = 0; c < list[a].days[b].eventListParent.length; c++) {
                    if (parseInt(id) == list[a].days[b].eventListParent[c].ID) {
                        currentDate = list[a].days[b].day
                        validObj = list[a].days[b]
                    }
                }
            }
        }
        if (validationList.length == 0) {
            for (var a = 0; a < list.length; a++) {
                for (var b = 0; b < list[a].days.length; b++) {
                    for (var c = 0; c < list[a].days[b].eventListChild.length; c++) {
                        // console.log(list[a].days[b])
                        if (parseInt(id) == list[a].days[b].eventListChild[c].ID) {
                            list[a].days[b].eventListChild[c].isSelected = true
                            validationList.push(list[a].days[b])
                        }
                    }
                    for (var c = 0; c < list[a].days[b].eventListParent.length; c++) {
                        if (parseInt(id) == list[a].days[b].eventListParent[c].ID) {
                            list[a].days[b].eventListParent[c].isSelected = true
                            validationList.push(list[a].days[b])
                        }
                    }
                }
            }
        }
        else {
            if (type == 0) {
                toBeFalse.push(parseInt(id))
                if (!validationDateList.includes(currentDate)) {
                    // ifDateCanBeRemoved = true
                    validationDateList.push(currentDate)
                    for (var a = 0; a < validObj.eventListChild.length; a++) {
                        if (parseInt(id) == validObj.eventListChild[a].ID) {
                            validObj.eventListChild[a].isSelected = true
                            validationList.push(validObj)
                        }
                    }
                    for (var a = 0; a < validObj.eventListParent.length; a++) {
                        if (parseInt(id) == validObj.eventListParent[a].ID) {
                            validObj.eventListParent[a].isSelected = true
                            validationList.push(validObj)
                        }
                    }
                }
                else {
                    for (var x = 0; x < validationList.length; x++) {
                        if (currentDate == validationList[x].day) {
                            for (var a = 0; a < validationList[x].eventListChild.length; a++) {
                                if (parseInt(id) == validationList[x].eventListChild[a].ID) {
                                    validationList[x].eventListChild[a].isSelected = true
                                    for (var b = 0; b < validationList[x].eventListParent.length; b++) {
                                        if (validationList[x].eventListParent[b].isSelected == true) {
                                            validationList[x].eventListParent[b].isSelected = false
                                            toBeTrue.push(validationList[x].eventListParent[b].ID)
                                        }
                                    }
                                }
                            }
                            for (var a = 0; a < validationList[x].eventListParent.length; a++) {
                                if (parseInt(id) == validationList[x].eventListParent[a].ID) {
                                    validationList[x].eventListParent[a].isSelected = true
                                    for (var b = 0; b < validationList[x].eventListChild.length; b++) {
                                        if (validationList[x].eventListChild[b].isSelected == true) {
                                            validationList[x].eventListChild[b].isSelected = false
                                            toBeTrue.push(validationList[x].eventListChild[b].ID)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            else {
                toBeTrue.push(parseInt(id))
                for (var x = 0; x < validationList.length; x++) {
                    if (currentDate == validationList[x].day) {
                        // console.log(validationList[x])
                        for (var a = 0; a < validationList[x].eventListChild.length; a++) {
                            if (parseInt(id) == validationList[x].eventListChild[a].ID) {
                                validationList[x].eventListChild[a].isSelected = false

                            }
                        }
                        for (var a = 0; a < validationList[x].eventListParent.length; a++) {
                            if (parseInt(id) == validationList[x].eventListParent[a].ID) {
                                validationList[x].eventListParent[a].isSelected = false
                            }
                        }
                    }
                }
            }
        }
        for (var i = 0; i < validationList.length; i++) {
            for (var j = 0; j < validationList.length - i - 1; j++) {
                var dateA = new Date(moment(validationList[j].day, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                var dateB = new Date(moment(validationList[j + 1].day, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                if (dateA > dateB) {
                    var tempvalidationList = validationList[j]
                    var tempvalidationDateList = validationDateList[j]
                    validationList[j] = validationList[j + 1]
                    validationDateList[j] = validationDateList[j + 1]
                    validationList[j + 1] = tempvalidationList
                    validationDateList[j + 1] = tempvalidationDateList
                }
            }
        }
        console.log('vefore======>', validationList, toBeFalse, toBeTrue)

        //checking
        var ERROR = false
        var startSlot = 0
        var endSlot = 0
        // var dumm = [0, 1, 1, 1, 0, 0, 0]
        // if (type == 0) {
        if (validationList.length == 1) {
            if (validationList[0].eventListParent.length > 0 && validationList[0].eventListParent[0].isSelected) {
                startSlot = 1
                endSlot = 1
            }
            else {
                for (var a = 0; a < validationList[0].eventListChild.length; a++) {
                    if (validationList[0].eventListChild[a].isSelected == true) {
                        startSlot = 1
                        for (var b = a; b < validationList[0].eventListChild.length; b++) {
                            if (validationList[0].eventListChild[b].isSelected == false) {
                                endSlot = 1
                                for (var c = b; c < validationList[0].eventListChild.length; c++) {
                                    if (validationList[0].eventListChild[c].isSelected == true) {
                                        ERROR = true
                                        break
                                    }
                                }
                                break
                            }
                        }
                        break
                    }
                }
            }
        }
        else if (validationList.length == 2) {
            for (var a = 0; a < validationDateList.length; a++) {
                if (validationDateList[a + 1] != undefined) {
                    var date1 = new Date(moment(validationDateList[a], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                    var date2 = new Date(moment(validationDateList[a + 1], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                    if ((Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) > 1 || (Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) < -1) {
                        console.log("err here")
                        ERROR = true
                        break
                    }
                }
            }
            if (validationList[0].eventListParent.length > 0 && validationList[0].eventListParent[0].isSelected == true) {
                startSlot = 1
            }
            else {
                for (var a = 0; a < validationList[0].eventListChild.length; a++) {
                    if (validationList[0].eventListChild[a].isSelected == true) {
                        startSlot = 1
                        for (var b = a; b < validationList[0].eventListChild.length; b++) {
                            if (validationList[0].eventListChild[b].isSelected == false) {
                                ERROR = true
                                break
                            }
                        }
                        break
                    }
                }
            }
            if (validationList[1].eventListParent > 0 && validationList[1].eventListParent[0].isSelected == true) {
                endSlot = 1
            }
            else {
                for (var a = validationList[1].eventListChild.length - 1; a >= 0; a--) {
                    if (validationList[1].eventListChild[a].isSelected == true) {
                        endSlot = 1
                        for (var b = a; b >= 0; b--) {
                            if (validationList[1].eventListChild[b].isSelected == false) {
                                ERROR = true
                                break
                            }
                        }
                        break
                    }
                }
            }
        }
        else {
            for (var a = 0; a < validationDateList.length; a++) {
                if (validationDateList[a + 1] != undefined) {
                    var date1 = new Date(moment(validationDateList[a], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                    var date2 = new Date(moment(validationDateList[a + 1], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                    if ((Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) > 1 || (Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) < -1) {
                        ERROR = true
                        break
                    }
                }
            }
            if (validationList[0].eventListParent.length > 0 && validationList[0].eventListParent[0].isSelected == true) {
                startSlot = 1
            }
            else {
                for (var a = 0; a < validationList[0].eventListChild.length; a++) {
                    if (validationList[0].eventListChild[a].isSelected == true) {
                        startSlot = 1
                        for (var b = a; b < validationList[0].eventListChild.length; b++) {
                            if (validationList[0].eventListChild[b].isSelected == false) {
                                ERROR = true
                                break
                            }
                        }
                        break
                    }
                }
            }
            if (validationList[validationList.length - 1].eventListParent.length > 0 && validationList[validationList.length - 1].eventListParent[0].isSelected == true) {
                endSlot = 1
            }
            else {
                for (var a = validationList[validationList.length - 1].eventListChild.length - 1; a >= 0; a--) {
                    if (validationList[validationList.length - 1].eventListChild[a].isSelected == true) {
                        endSlot = 1
                        for (var b = a; b >= 0; b--) {
                            if (validationList[validationList.length - 1].eventListChild[b].isSelected == false) {
                                ERROR = true
                                break
                            }
                        }
                        break
                    }
                }
            }
            for (var a = 1; a < validationList.length - 1; a++) {
                if (validationList[a].eventListParent.length > 0 && validationList[a].eventListParent[0].isSelected != true) {
                    // else {
                    for (var b = 0; b < validationList[a].eventListChild.length; b++) {
                        if (validationList[a].eventListChild[b].isSelected == false) {
                            ERROR = true
                            break
                        }
                    }
                    // }
                }
            }

        }
        // console.log('isDatesOverFlow', isDatesOverFlow)
        if (validationList.length > 1) {

            if (isDatesOverFlow == 1) {
                if (currentDate == validationList[validationList.length - 1].day) {
                    for (var a = 0; a < validationList[validationList.length - 1].eventListParent.length; a++) {
                        if (validationList[validationList.length - 1].eventListParent[a].isSelected != true) {
                            for (var b = 0; b < validationList[validationList.length - 1].eventListChild.length; b++) {
                                if (validationList[validationList.length - 1].eventListChild[b].isSelected != true) {
                                    ERROR = true
                                    break
                                }
                            }
                        }
                    }
                }
            }
            else if (isDatesOverFlow == 2) {
                if (currentDate == validationList[0].day) {
                    for (var a = 0; a < validationList[0].eventListParent.length; a++) {
                        if (validationList[0].eventListParent[a].isSelected != true) {
                            for (var b = 0; b < validationList[0].eventListChild.length; b++) {
                                if (validationList[0].eventListChild[b].isSelected != true) {
                                    ERROR = true
                                    break
                                }
                            }
                        }
                    }
                }
            }
            else if (isDatesOverFlow == 3) {
                if (currentDate == validationList[0].day) {
                    for (var a = 0; a < validationList[0].eventListParent.length; a++) {
                        if (validationList[0].eventListParent[a].isSelected != true) {
                            for (var b = 0; b < validationList[0].eventListChild.length; b++) {
                                if (validationList[0].eventListChild[b].isSelected != true) {
                                    ERROR = true
                                    break
                                }
                            }
                        }
                    }
                }
                else if (currentDate == validationList[validationList.length - 1].day) {
                    for (var a = 0; a < validationList[validationList.length - 1].eventListParent.length; a++) {
                        if (validationList[validationList.length - 1].eventListParent[a].isSelected != true) {
                            for (var b = 0; b < validationList[validationList.length - 1].eventListChild.length; b++) {
                                if (validationList[validationList.length - 1].eventListChild[b].isSelected != true) {
                                    ERROR = true
                                    break
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            if (isDatesOverFlow == 1) {
                if (validationList[0].eventListParent.length > 0 && validationList[0].eventListParent[0].isSelected != true) {
                    for (var a = 0; a < validationList[0].eventListChild.length; a++) {
                        if (validationList[0].eventListChild[a].isSelected == true) {
                            for (var b = a; b < validationList[0].eventListChild.length; b++) {
                                if (validationList[0].eventListChild[b].isSelected == false) {
                                    ERROR = true
                                    break
                                }
                            }
                            break
                        }
                    }
                }
            }
            if (isDatesOverFlow == 2) {
                if (validationList[validationList.length - 1].eventListParent.length > 0 && validationList[validationList.length - 1].eventListParent[0].isSelected != true) {
                    for (var a = validationList[validationList.length - 1].eventListChild.length - 1; a >= 0; a--) {
                        if (validationList[validationList.length - 1].eventListChild[a].isSelected == true) {
                            for (var b = a; b >= 0; b--) {
                                if (validationList[validationList.length - 1].eventListChild[b].isSelected == false) {
                                    ERROR = true
                                    break
                                }
                            }
                            break
                        }
                    }
                }
            }
        }


        for (var a = 0; a < validationDateList.length; a++) {
            if (validationDateList[a + 1] != undefined) {
                var date1 = new Date(moment(validationDateList[a], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                var date2 = new Date(moment(validationDateList[a + 1], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                if ((Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) > 1 || (Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)) < -1) {
                    ERROR = true
                    break
                }
            }
        }
        if (ERROR == true) {
            // if (ifDateCanBeRemoved) {
            //     for (var a = 0; a < validationList.length; a++) {
            //         if (currentDate == validationList[a].day) {
            //             validationList.splice(a, 1)
            //             validationDateList.splice(a, 1)
            //         }
            //     }
            // }
            // else {
            console.log(toBeFalse, toBeTrue)
            for (var a = 0; a < validationList.length; a++) {
                if (currentDate == validationList[a].day) {
                    for (var b = 0; b < validationList[a].eventListChild.length; b++) {
                        if (toBeTrue.includes(validationList[a].eventListChild[b].ID)) {
                            validationList[a].eventListChild[b].isSelected = true
                        }
                        if (toBeFalse.includes(validationList[a].eventListChild[b].ID)) {
                            validationList[a].eventListChild[b].isSelected = false
                        }
                    }
                    for (var b = 0; b < validationList[a].eventListParent.length; b++) {
                        if (toBeTrue.includes(validationList[a].eventListParent[b].ID)) {
                            validationList[a].eventListParent[b].isSelected = true
                        }
                        if (toBeFalse.includes(validationList[a].eventListParent[b].ID)) {
                            validationList[a].eventListParent[b].isSelected = false
                        }
                    }
                }
            }
            for (var a = 0; a < validationList.length; a++) {
                var checkforisSelectArr = []
                if (validationList[a].eventListParent.length > 0 && validationList[a].eventListParent[0].isSelected != true) {
                    for (var b = 0; b < validationList[a].eventListChild.length; b++) {
                        checkforisSelectArr.push(validationList[a].eventListChild[b].isSelected)
                    }
                    if (!checkforisSelectArr.includes(true)) {
                        validationList.splice(a, 1)
                        validationDateList.splice(a, 1)
                    }
                }
            }
            // }
        }
        else {
            for (var a = 0; a < validationList.length; a++) {
                var checkforisSelectArr = []
                if (validationList[a].eventListParent.length > 0 && validationList[a].eventListParent[0].isSelected != true) {
                    for (var b = 0; b < validationList[a].eventListChild.length; b++) {
                        checkforisSelectArr.push(validationList[a].eventListChild[b].isSelected)
                    }
                    if (!checkforisSelectArr.includes(true)) {
                        validationList.splice(a, 1)
                        validationDateList.splice(a, 1)
                    }
                }
            }

        }
        // this.setState({ validationDateList: validationDateList })

        sessionStorage.setItem('validationDateList', JSON.stringify(validationDateList))
        setTimeout(() => {

            console.log('after======>', validationDateList, validationDateList, validationList, ERROR)
        }, 250);

        return ERROR

    }

    onSelect(selectedValue) {
        const { selectedCenter, selectedIDList, finalList, duplicateFinalList, validationList, timeSlotIDList, timeSlotList, timeSlot, BlockCalenderList, bookingList, calenderList } = this.state
        // console.log(selectedValue)
        var calendarID
        var clientID = null
        var timeslotID
        // console.log(selectedValue, selectedIDList)
        if (!selectedIDList.includes(parseInt(selectedValue))) {
            var tempIDlist = []
            for (var a = 0; a < bookingList.length; a++) {
                tempIDlist.push(parseInt(bookingList[a].CalendarID))
            }
            tempIDlist.push(parseInt(selectedValue))
            var otherChildArr = []
            var otherchildIncludes = true
            var parentID = null
            var fullSlotsPresent = false
            var centerID = null
            console.log(calenderList, finalList, timeSlotIDList, timeSlotList)
            for (var s = 0; s < calenderList.length; s++) {
                if (parseInt(calenderList[s].CalendarID) == selectedValue) {
                    parentID = parseInt(calenderList[s].ParentCalendarID)
                    centerID = parseInt(calenderList[s].CenterID)
                }
            }
            for (var s = 0; s < finalList.length; s++) {
                if (parseInt(calenderList[s].CalendarID) == selectedValue) {
                    parentID = parseInt(calenderList[s].ParentCalendarID)
                    centerID = parseInt(calenderList[s].CenterID)
                }
            }

            //creating arr to check all childs
            if (duplicateFinalList.length > 0) {
                for (var s = 0; s < duplicateFinalList.length; s++) {
                    if (duplicateFinalList[s].centerID == centerID) {
                        fullSlotsPresent = duplicateFinalList[s].fullSlotsSelected
                    }
                }
            } else {
                fullSlotsPresent = true
            }
            console.log('duplicateFinalList', duplicateFinalList, fullSlotsPresent)
            for (var s = 0; s < calenderList.length; s++) {
                if (parentID == calenderList[s].ParentCalendarID && parentID != null) {
                    otherChildArr.push(calenderList[s].CalendarID)
                }
            }
            if (parentID != null) {
                if (otherChildArr.length > 0) {
                    for (var t = 0; t < otherChildArr.length; t++) {
                        // console.log('1selectedIDList===>', tempIDlist.includes(otherChildArr[t]))
                        if (!tempIDlist.includes(otherChildArr[t])) {
                            // console.log('2===>', otherChildArr, otherchildIncludes, selectedIDList)
                            otherchildIncludes = false
                            break
                        }
                    }
                } else {
                    otherchildIncludes = false
                }
            } else {
                otherchildIncludes = false
            }

            if (otherchildIncludes && fullSlotsPresent) {
                for (var a = 0; a < calenderList.length; a++) {
                    if (selectedValue == calenderList[a].CalendarID) {
                        bookingList.push(calenderList[a])
                        calendarID = selectedValue
                        timeslotID = calenderList[a].TimeslotID
                        BlockCalenderList.push({
                            'calendarID': parseInt(calendarID),
                            'clientID': clientID,
                            'timeslotID': timeslotID
                        })
                        selectedIDList.push(parseInt(selectedValue))
                    }
                }
                selectedValue = parentID
                var res = this.selectValidation(selectedValue, 0)
                if (res == false) {
                    for (var a = 0; a < calenderList.length; a++) {
                        if (selectedValue == calenderList[a].CalendarID) {
                            bookingList.push(calenderList[a])
                            calendarID = selectedValue
                            timeslotID = calenderList[a].TimeslotID
                            BlockCalenderList.push({
                                'calendarID': parseInt(calendarID),
                                'clientID': clientID,
                                'timeslotID': timeslotID
                            })
                            selectedIDList.push(parseInt(selectedValue))
                            // console.log('finalss===>', this.state.bookingList, selectedIDList, BlockCalenderList, tempIDlist, otherChildArr)
                            for (var t = 0; t < otherChildArr.length; t++) {
                                for (var s = 0; s < selectedIDList.length; s++) {
                                    if (otherChildArr[t] == selectedIDList[s]) {
                                        selectedIDList.splice(s, 1)
                                        bookingList.splice(s, 1)
                                        BlockCalenderList.splice(s, 1)
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    this.toggleModal2()
                }
            } else {
                var res = this.selectValidation(selectedValue, 0)
                // console.log(res)
                if (res == false) {
                    for (var a = 0; a < calenderList.length; a++) {
                        if (selectedValue == calenderList[a].CalendarID) {
                            bookingList.push(calenderList[a])
                            calendarID = selectedValue
                            timeslotID = calenderList[a].TimeslotID
                            BlockCalenderList.push({
                                'calendarID': parseInt(calendarID),
                                'clientID': clientID,
                                'timeslotID': timeslotID
                            })
                            if (calenderList[a].ParentCalendarID != null) {
                                for (var s = 0; s < selectedIDList.length; s++) {
                                    if (calenderList[a].ParentCalendarID == selectedIDList[s]) {
                                        selectedIDList.splice(s, 1)
                                        bookingList.splice(s, 1)
                                        BlockCalenderList.splice(s, 1)
                                    }
                                }
                            }

                            if (calenderList[a].ChildCalendarID != null) {
                                var arr = calenderList[a].ChildCalendarID.split(',')
                                for (var par = 0; par < arr.length; par++) {
                                    arr[par] = parseInt(arr[par])
                                }
                                for (var l = 0; l < arr.length; l++) {
                                    for (var q = 0; q < selectedIDList.length; q++) {
                                        if (arr[l] == selectedIDList[q]) {
                                            selectedIDList.splice(q, 1)
                                            bookingList.splice(q, 1)
                                            BlockCalenderList.splice(q, 1)
                                        }
                                    }
                                }
                            }
                            selectedIDList.push(parseInt(selectedValue))
                        }
                    }
                }
                else {
                    this.toggleModal2()
                }
            }
        }
        else {
            var res = this.selectValidation(selectedValue, 1)
            // console.log(res)
            if (res == false) {
                for (var i = 0; i < selectedIDList.length; i++) {
                    if (selectedValue == selectedIDList[i]) {
                        // if (i == 0 || i == selectedIDList.length - 1) {
                        selectedIDList.splice(i, 1)
                        bookingList.splice(i, 1)
                        BlockCalenderList.splice(i, 1)
                        // }
                        // else {
                        //     this.toggleModal2()
                        // }
                    }
                }
            }
            else {
                this.toggleModal2()
            }
        }

        // console.log(selectedIDList.length)
        if (selectedIDList.length == 0) {
            this.setState({ selectedCenter: '' })
        }
        else {
            for (var i = 0; i < calenderList.length; i++) {
                if (selectedValue == calenderList[i].CalendarID) {
                    this.setState({ selectedCenter: calenderList[i].CenterID })
                }
            }
        }
        for (var i = 0; i < bookingList.length; i++) {
            for (var j = 0; j < bookingList.length - i - 1; j++) {
                var dateA = new Date(moment(bookingList[j].Date, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                var dateB = new Date(moment(bookingList[j + 1].Date, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                if (dateA > dateB) {
                    var tempBookinglist = bookingList[j]
                    var tempSelectedList = selectedIDList[j]
                    var tempBlockCalenderList = BlockCalenderList[j]
                    bookingList[j] = bookingList[j + 1]
                    selectedIDList[j] = selectedIDList[j + 1]
                    BlockCalenderList[j] = BlockCalenderList[j + 1]
                    bookingList[j + 1] = tempBookinglist
                    selectedIDList[j + 1] = tempSelectedList
                    BlockCalenderList[j + 1] = tempBlockCalenderList
                }
            }
        }


        sessionStorage.setItem('bookArray', bookingList.length == 0 ? null : JSON.stringify(bookingList))
        setTimeout(() => {
            // console.log(JSON.parse(sessionStorage.getItem('bookArray')))
            console.log("BlockCalenderList", JSON.parse(sessionStorage.getItem('bookArray')), BlockCalenderList)

            console.log(this.state.bookingList, selectedIDList, BlockCalenderList, validationList,)
        }, 500);
    }

    updateSearch() {
        var time = []
        for (var i = 0; i < this.state.timeSlot.length; i++) {
            time.push(this.state.timeSlot[i].value)
        }
        console.log('time', time)
        this.setState({ timeSlotIDList: time })
        setTimeout(() => {
            this.getCalender()
            // console.log(this.state.cityId)
        }, 200);
    }

    getCalender() {
        const { cityId, venueId, bookingDate, newDate, timeSlotIDList, } = this.state
        this.setState({ isLoading: true })
        console.log(venueId)
        this.props
            .search_calender_action((cityId == '' || cityId == null) ? null : cityId, (venueId == '' || venueId == null) ? null : venueId, (bookingDate == '' || bookingDate == null) ? (newDate == '' || newDate == null) ? null : newDate : bookingDate, (timeSlotIDList == '' || timeSlotIDList == null) ? null : timeSlotIDList.toString(), 0)
            .then((data) => {
                console.log("search get data===>", data.data)
                data.data.map(item => {
                    item.ISITMEClient == 1 && console.log("search get data===>", item)
                })
                this.createFinalList(data, 0)
            })
            .catch((e) => {
                console.log(e);
            });
        if (timeSlotIDList != '' && timeSlotIDList != null) {
            this.props
                .search_calender_action((cityId == '' || cityId == null) ? null : cityId, (venueId == '' || venueId == null) ? null : venueId, (bookingDate == '' || bookingDate == null) ? (newDate == '' || newDate == null) ? null : newDate : bookingDate, null, 0)
                .then((data) => {
                    // console.log("search get data===>", data)
                    this.createFinalList(data, 1)
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }

    createFinalList(data, button) {
        var daysArr = []
        var dateArr = []
        var centerArr = []
        var demoARR = []
        var finalARR = []
        var holidayArr = []
        // this.setState({ isLoading: false })
        this.setState({ calenderList: data.data })


        //centerARR to get corresponding data of center
        //list for no of centers == demoarr
        for (var j = 0; j < data.data.length; j++) {
            if (centerArr.includes(data.data[j].CenterID) == false
                // && (data.data[j].PARENTCENTERID == 0 || data.data[j].PARENTCENTERID == null)
            ) {
                centerArr.push(data.data[j].CenterID)
                demoARR.push(data.data[j])
            }
            if (data.data[j].StatusID == 4) {
                if (!holidayArr.includes(data.data[j].Date)) {
                    holidayArr.push(data.data[j].Date)
                }
            }
            if (data.data[j].OrderID != this.state.OrderID) {
                if (data.data[j].StatusID != 1) {
                    if (data.data[j].ParentCalendarID != null) {

                        // if (!this.state.blockedList.includes(data.data[j].ParentCalendarID)) {
                        this.state.blockedList.push(data.data[j].ParentCalendarID)
                        // }

                    }
                    if (data.data[j].ChildCalendarID != null) {
                        var arr = data.data[j].ChildCalendarID.split(',')
                        for (var par = 0; par < arr.length; par++) {
                            this.state.blockedList.push(parseInt(arr[par]))
                        }
                    }
                }
            }
        }
        // console.log('OOOOOOOOOOOOOO', demoARR, centerArr)
        for (var i = 0; i < demoARR.length; i++) {
            var noOfSlots = []
            var fullSlotsSelected = true
            for (var j = 0; j < data.data.length; j++) {
                if (demoARR[i].CenterID == data.data[j].CenterID) {
                    if (!noOfSlots.includes(data.data[j].TimeslotID)) {
                        noOfSlots.push(data.data[j].TimeslotID)
                    }
                }
            }
            demoARR[i].noOfSlots = noOfSlots
            if (this.state.timeSlotIDList.length != 0) {
                for (var j = 0; j < noOfSlots.length; j++) {
                    if (!this.state.timeSlotIDList.includes(noOfSlots[j])) {
                        fullSlotsSelected = false
                    }
                }
            }
            demoARR[i].fullSlotsSelected = fullSlotsSelected
        }
        console.log('hol', demoARR)
        //dateARR to get corresponding days for daysARR
        //list for date and day header == daysArr
        for (var i = 0; i < data.data.length; i++) {
            var dateOBJ2 = {}
            if (dateArr.includes(data.data[i].Date) == false) {
                dateArr.push(data.data[i].Date)
                dateOBJ2.date = data.data[i].Date
                dateOBJ2.day = data.data[i].Day
                daysArr.push(dateOBJ2)
            }
        }
        this.setState({ dateList: dateArr })
        //final list to render get with demo arr, days arr and data
        for (var i = 0; i < demoARR.length; i++) {
            var centerObj = {}
            var dateArr2 = []
            centerObj.centerID = demoARR[i].CenterID
            centerObj.noOfSlots = demoARR[i].noOfSlots
            centerObj.fullSlotsSelected = demoARR[i].fullSlotsSelected
            centerObj.centerCode = demoARR[i].CenterCode
            centerObj.centerName = demoARR[i].CenterName
            centerObj.isSaturdayOff = demoARR[i].isSaturdayOff
            centerObj.isSundayOff = demoARR[i].isSundayOff
            centerObj.url = demoARR[i].URL
            centerObj.cityId = demoARR[i].CityID
            centerObj.parentcenterID = (demoARR[i].PARENTCENTERID == 0 || demoARR[i].PARENTCENTERID == null ? null : demoARR[i].PARENTCENTERID)
            centerObj.subCenterID = demoARR[i].SubCenterID
            centerObj.parentcenterName = demoARR[i].ParentCenter
            for (var a = 0; a < dateArr.length; a++) {
                var dateOBJ = {}
                dateOBJ.day = dateArr[a]
                dateOBJ.booked = null
                dateOBJ.dayName = null
                dateOBJ.ISITMEClient = 0
                // console.log('=======>', dateOBJ)
                dateArr2.push(dateOBJ)
            }
            centerObj.days = dateArr2
            finalARR.push(centerObj)
        }

        for (var i = 0; i < finalARR.length; i++) {
            for (var j = 0; j < finalARR[i].days.length; j++) {
                var eventChildARR = []
                var eventParentARR = []
                var statusARR = []
                for (var k = 0; k < data.data.length; k++) {
                    // console.log('finalARR[i]', finalARR[i].days[j].day, data.data[k].Date)
                    if (finalARR[i].days[j].day == data.data[k].Date) {
                        finalARR[i].days[j].dayName = data.data[k].Day
                    }
                    var eventOBJ = {}
                    if (finalARR[i].centerID == data.data[k].CenterID && data.data[k].ParentCalendarID != null) {
                        if (finalARR[i].days[j].day == data.data[k].Date) {
                            eventOBJ.Timeslot = data.data[k].Timeslot
                            // eventOBJ.isSundayOff = data.data[k].isSundayOff
                            eventOBJ.name = data.data[k].TimeSlotName
                            eventOBJ.slotID = data.data[k].TimeslotID
                            statusARR.push(data.data[k].StatusID)
                            eventOBJ.status = data.data[k].StatusID
                            eventOBJ.stat = data.data[k].Status
                            eventOBJ.orderID = data.data[k].OrderID
                            eventOBJ.ID = data.data[k].CalendarID
                            eventOBJ.isLock = data.data[k].IsLock
                            eventOBJ.ISITMEClient = data.data[k].ISITMEClient
                            if (data.data[k].ISITMEClient == 1) {
                                finalARR[i].days[j].ISITMEClient = 1
                            }
                            eventChildARR.push(eventOBJ)
                        }
                    }
                    if (finalARR[i].centerID == data.data[k].CenterID && data.data[k].ParentCalendarID == null) {
                        if (finalARR[i].days[j].day == data.data[k].Date) {
                            eventOBJ.Timeslot = data.data[k].Timeslot
                            eventOBJ.name = data.data[k].TimeSlotName
                            eventOBJ.slotID = data.data[k].TimeslotID
                            statusARR.push(data.data[k].StatusID)
                            eventOBJ.status = data.data[k].StatusID
                            eventOBJ.stat = data.data[k].Status
                            eventOBJ.orderID = data.data[k].OrderID
                            eventOBJ.ID = data.data[k].CalendarID
                            eventOBJ.isLock = data.data[k].IsLock
                            eventOBJ.ISITMEClient = data.data[k].ISITMEClient
                            if (data.data[k].ISITMEClient == 1) {
                                finalARR[i].days[j].ISITMEClient = 1
                            }
                            eventParentARR.push(eventOBJ)
                            // console.log(finalARR[i].days[j])
                        }
                    }
                }
                if (statusARR.includes(1)) {
                    finalARR[i].days[j].booked = 0
                }

                // else {
                //     finalARR[i].days[j].booked = 1
                // }
                finalARR[i].days[j].eventListChild = eventChildARR
                finalARR[i].days[j].eventListParent = eventParentARR
            }
        }

        for (var i = 0; i < finalARR.length; i++) {
            for (var j = 0; j < finalARR[i].days.length; j++) {
                finalARR[i].days[j].noOfSlots = finalARR[i].days[j].eventListChild.length
                for (var a = 0; a < finalARR[i].days[j].eventListChild.length; a++) {
                    finalARR[i].days[j].eventListChild[a].slotNo = a
                    finalARR[i].days[j].eventListChild[a].isParent = 0
                    finalARR[i].days[j].eventListChild[a].isSelected = false

                }
                for (var a = 0; a < finalARR[i].days[j].eventListParent.length; a++) {
                    finalARR[i].days[j].eventListParent[a].isParent = 1
                    finalARR[i].days[j].eventListParent[a].isSelected = false
                }
            }
        }

        // if (this.state.isComingFromDiffPage) {
        console.log(this.state.selectedIDList)
        // var dateList = []
        if (this.state.selectedIDList.length > 0) {
            for (var i = 0; i < finalARR.length; i++) {
                for (var j = 0; j < finalARR[i].days.length; j++) {
                    for (var x = 0; x < this.state.selectedIDList.length; x++) {
                        for (var k = 0; k < finalARR[i].days[j].eventListChild.length; k++) {
                            if (this.state.selectedIDList[x] == finalARR[i].days[j].eventListChild[k].ID) {
                                if (!this.state.validationDateList.includes(finalARR[i].days[j].day)) {
                                    this.state.validationDateList.push(finalARR[i].days[j].day)
                                    this.state.validationList.push(finalARR[i].days[j])
                                }
                            }
                        }
                        for (var k = 0; k < finalARR[i].days[j].eventListParent.length; k++) {
                            if (this.state.selectedIDList[x] == finalARR[i].days[j].eventListParent[k].ID) {
                                if (!this.state.validationDateList.includes(finalARR[i].days[j].day)) {
                                    this.state.validationDateList.push(finalARR[i].days[j].day)
                                    this.state.validationList.push(finalARR[i].days[j])
                                }
                            }
                        }
                    }
                }
            }
        }

        for (var a = 0; a < this.state.validationList.length; a++) {
            for (var b = 0; b < this.state.validationList[a].eventListChild.length; b++) {
                if (this.state.selectedIDList.includes(this.state.validationList[a].eventListChild[b].ID)) {
                    this.state.validationList[a].eventListChild[b].isSelected = true

                }
            }
            for (var b = 0; b < this.state.validationList[a].eventListParent.length; b++) {
                if (this.state.selectedIDList.includes(this.state.validationList[a].eventListParent[b].ID)) {
                    this.state.validationList[a].eventListParent[b].isSelected = true
                }
            }
        }

        if (JSON.parse(sessionStorage.getItem('validationDateList')) != null && JSON.parse(sessionStorage.getItem('validationDateList')).length > 0) {
            var differentDates = []
            var datePlus = false
            var dateMinus = false
            var valid1stDate = new Date(moment(this.state.validationDateList[0], 'DD-MM-YYYY').format('YYYY-MM-DD'))
            for (var i = 0; i < JSON.parse(sessionStorage.getItem('validationDateList')).length; i++) {
                if (!this.state.validationDateList.includes(JSON.parse(sessionStorage.getItem('validationDateList'))[i])) {
                    differentDates.push(JSON.parse(sessionStorage.getItem('validationDateList'))[i])
                }
            }
            if (differentDates.length > 0) {
                for (var i = 0; i < differentDates.length; i++) {
                    var diffDate = new Date(moment(differentDates[i], 'DD-MM-YYYY').format('YYYY-MM-DD'))
                    if (Math.sign(Math.abs(diffDate.getTime() - valid1stDate.getTime()) / (1000 * 3600 * 24)) == 1) {
                        datePlus = true
                    }
                    else if (Math.sign(Math.abs(diffDate.getTime() - valid1stDate.getTime()) / (1000 * 3600 * 24)) == -1) {
                        dateMinus = true
                    }
                }
                if (datePlus == true && dateMinus == false) {
                    this.setState({ isDatesOverFlow: 1 })
                }
                else if (datePlus == false && dateMinus == true) {
                    this.setState({ isDatesOverFlow: 2 })
                }
                else if (datePlus == true && dateMinus == true) {
                    this.setState({ isDatesOverFlow: 3 })
                }
                else {
                    this.setState({ isDatesOverFlow: null })
                }
            }
            else {
                this.setState({ isDatesOverFlow: null })
            }
        }
        else {
            this.setState({ isDatesOverFlow: null })
        }

        setTimeout(() => {
            console.log("finalARR", finalARR)

            this.setState({ holidayArr: holidayArr })
            if (button == 1) {
                this.setState({ duplicateFinalList: finalARR })
            }
            else {
                this.setState({ finalList: finalARR })
            }
            this.setState({ finalDateList: daysArr })
            this.setState({ isLoading: false })
            // console.log("days", daysArr)
            // console.log("date", dateArr)
            // console.log('valll', this.state.startsValidationNo, this.state.endValidationNo, this.state.validationList)
            // console.log("center", centerArr)
            // console.log("center info", demoARR)
            // console.log("final list to populate data on page", finalARR)
            // console.log("final;", finalARR[1].subCenterID[2])
        }, 300);
    }

    prevWeek() {
        this.setState({ bookingDate: '' })
        const { dateList, newDate } = this.state
        if (dateList.length != 0) {
            var date = new Date(`${dateList[0].slice(3, 5)}/${dateList[0].slice(0, 2)}/${dateList[0].slice(6)}`)
            date.setDate(date.getDate() - 7)
            // console.log(date)
            this.setState({ newDate: date })
        }
        else {
            if (newDate != '' && newDate != null) {
                var date = newDate
                date.setDate(date.getDate() - 7)
                // console.log(date)
                this.setState({ newDate: date })
            }
        }
        setTimeout(() => {
            this.getCalender()
        }, 200);
    }

    nextWeek() {
        const { dateList, newDate, bookingDate } = this.state
        this.setState({ bookingDate: '' })
        if (dateList.length != 0) {
            var date = new Date(`${dateList[dateList.length - 1].slice(3, 5)}/${dateList[dateList.length - 1].slice(0, 2)}/${dateList[dateList.length - 1].slice(6)}`)
            date.setDate((date.getDate() + 7))
            // console.log(date)
            this.setState({ newDate: date })
        }
        else {
            if (newDate != '' && newDate != null) {
                var date = newDate
                date.setDate((date.getDate() + 7))
                // console.log(date)
                this.setState({ newDate: date })
            }
        }
        setTimeout(() => {
            // console.log(this.state.newDate)
            this.getCalender()
        }, 200);
    }

    openCalenderView(data) {
        // console.log(data)
        this.props.navigate('/calenderView', { state: { centerID: data.centerID, venueName: data.centerName } })
    }

    onBook() {
        const { bookingList, isEdit } = this.state
        if (JSON.parse(sessionStorage.getItem('UserLoginData')) != null) {
            this.props.navigate('/companyInfo', { state: { Is_CenterID: true, isEdit: isEdit } })
        }
        else {
            this.props.navigate('/login', { state: { companyInfo: true, Is_CenterID: true, isEdit: isEdit } })
        }
        // console.log(bookingList)
    }

    clearSearch() {
        if (JSON.parse(sessionStorage.getItem('Is_modify')) == true) {
            this.setState({
                bookingDate: '',
                newDate: '',
                timeSlot: [],
                timeSlotIDList: []
            })
        }
        else {
            this.setState({
                cityId: '',
                venueId: '',
                bookingDate: '',
                newDate: '',
                timeSlot: [],
                timeSlotIDList: []
            })
        }

        setTimeout(() => {
            this.getCalender()
        }, 200);
    }

    clearSelected() {
        sessionStorage.removeItem('bookArray')
        sessionStorage.removeItem('validationDateList')
        sessionStorage.removeItem('centerID')
        this.setState({ bookingList: [], selectedIDList: [], selectedCenter: '', validationDateList: [], BlockCalenderList: [], validationList: [] })
    }

    toggleModal() {
        const { isOpen } = this.state
        this.setState({ isOpen: !isOpen })
        // if (ClientID == '') {
        //     return
        // }
        // else {
        //     this.setState({ clientDeleteId: ClientID })
        // }
    }

    onClientSelect(clientID) {
        this.setState({ clientID: clientID })
        const { BlockCalenderList } = this.state
        // console.log(clientID)
        for (var i = 0; i < BlockCalenderList.length; i++) {
            BlockCalenderList[i].clientID = clientID
        }
        // console.log(BlockCalenderList)
    }

    handleBlockCalender() {
        const { BlockCalenderList, clientID, userID } = this.state
        this.setState({ isLoading: true })
        // if
        for (var i = 0; i < BlockCalenderList.length; i++) {
            BlockCalenderList[i].clientID = clientID
        }
        this.props.block_calender_action(BlockCalenderList, userID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Blocked Successfully")
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                        sessionStorage.removeItem('bookArray')
                        sessionStorage.removeItem('validationDateList')
                        // sessionStorage.removeItem('validationList')
                        // this.setState({ bookingList: [], selectedIDList: [], selectedCenter: '', BlockCalenderList: [], clientID: '' })
                        this.setState({ bookingList: [], selectedIDList: [], selectedCenter: '', validationDateList: [], BlockCalenderList: [], validationList: [] })
                        this.toggleModal()
                        this.getCalender()
                    }, 300);

                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // render pincode
    renderClientList() {
        const { clientList, Pincode, tempClientList, clientID } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempClientList.length > 0 && tempClientList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                clientID: data.ClientID,
                                isDisplayClientList: false,
                                clientName: data.Client,
                            })}
                        >{data.Client}</li>

                    ))
                }
            </ul>
        )
    }
    // search 
    onClientSearch(e) {
        const { clientList, tempClientList } = this.state
        // console.log("onClientSearch 123", tempClientList)
        if (e.target.value != '') {
            // console.log(this.state.BlockCalenderList)
            var searchClientList = tempClientList.filter(data => {
                return (
                    data
                        .Client
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            // console.log('pincodeCount', searchClientList.length)
            this.setState({
                clientName: e.target.value,
                // pincodeErr: '',
                tempClientList: searchClientList,
                isDisplayClientList: true
            })
        } else {
            this.setState({
                clientName: e.target.value,
                tempClientList: clientList,
                isDisplayClientList: false
            })
        }
    }

    renderSlots(data, days) {
        const { selectedCenter, blockedList, selectedIDList } = this.state
        return (<>
            {days.eventListChild.length > 0 && days.eventListChild.map((event) => (
                <>{
                    (selectedCenter == '' || selectedCenter == null) ? <>
                        {(((event.status == 1 && event.isLock != 1) || event.orderID == this.state.OrderID) && !blockedList.includes(event.ID)) ? <div class="inputGroup">
                            <input
                                checked={selectedIDList.includes(event.ID)}
                                onClick={e => this.onSelect(e.target.value)} value={event.ID}
                                id={event.ID} name={event.ID} type="checkbox" />
                            <label for={event.ID} >{event.name}</label>
                        </div> : <label class={'table_labels selected_color table_content_bg'}>{event.name}</label>
                        }
                    </> : <>
                        {(((event.status == 1 && event.isLock != 1 && data.centerID == selectedCenter) || event.orderID == this.state.OrderID) && !blockedList.includes(event.ID)) ? <div class="inputGroup">
                            <input
                                checked={selectedIDList.includes(event.ID)}
                                onClick={e => this.onSelect(e.target.value)} value={event.ID}
                                id={event.ID} name={event.ID} type="checkbox" />
                            <label for={event.ID} >{event.name}</label>
                        </div> : <label class={'table_labels selected_color table_content_bg'}>{event.name}</label>}
                    </>
                }
                </>
            ))}
            {((days.eventListParent.length > 0 && days.eventListChild.length > 0)) && <div class={days.ISITMEClient == 1 ? 'text-white separator' : 'separator'}>OR</div>}
            {days.eventListParent.length > 0 && days.eventListParent.map((event) => (
                <>{
                    (selectedCenter == '' || selectedCenter == null) ? <>
                        {(((event.status == 1 && event.isLock != 1) || event.orderID == this.state.OrderID) && !blockedList.includes(event.ID)) ? <div class="inputGroup">
                            <input
                                checked={selectedIDList.includes(event.ID)}
                                onClick={e => this.onSelect(e.target.value)} value={event.ID}
                                id={event.ID} name={event.ID} type="checkbox" />
                            <label for={event.ID} >{event.name}</label>
                        </div> : <label class={'table_labels selected_color table_content_bg'}>{event.name}</label>
                        }
                    </> : <>
                        {(((event.status == 1 && event.isLock != 1 && data.centerID == selectedCenter) || event.orderID == this.state.OrderID) && !blockedList.includes(event.ID)) ? <div class="inputGroup">
                            <input
                                checked={selectedIDList.includes(event.ID)}
                                onClick={e => this.onSelect(e.target.value)} value={event.ID}
                                id={event.ID} name={event.ID} type="checkbox" />
                            <label for={event.ID} >{event.name}</label>
                        </div> : <label class={'table_labels selected_color table_content_bg'}>{event.name}</label>}
                    </>
                }
                </>
            ))}
        </>)
    }


    render() {
        const { isLoading, holidayArr, bookingList, BlockCalenderList,
            clientList, clientID, cityId, isOpen, selectedCenter, cityList,
            selectedIDList, venueId, venueList, bookingDate, isOpen2, timeSlot,
            timeSlotList, blockedList, isSiteMaintenance } = this.state
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        return (
            <>
                {isSiteMaintenance ? <SiteMaintenance /> : (isLoading ? (<Loader></Loader>) : (null))}
                <ToastContainer />
                {/* <AdminHeader isSteper={false}/> */}
                <>
                    <main id="main">
                        <Header data={[2]} />
                        <section id="search_panel" class="search_panel">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-2 col-sm-3 col-6 offset-1 offset-sm-0">
                                                <div class="form-group mb_0">
                                                    <label>
                                                        Location
                                                    </label>
                                                    {/* <select
                                                        className={this.state.cityId != '' && this.state.cityId != 'Select' ? "form-control text-dark" : "form-control"}
                                                        style={{ width: "100%" }}
                                                        disabled={JSON.parse(sessionStorage.getItem('Is_modify')) == true}
                                                        value={cityId}
                                                        onChange={e => this.setState({ cityId: e.target.value })}
                                                    >
                                                        <option value={''}>Select</option>
                                                        {cityList.length > 0 ? cityList.map(data => (
                                                            <option
                                                                key={data.Code}
                                                                value={data.Code}>
                                                                {data.CityName}
                                                            </option>
                                                        )) : <></>}
                                                    </select> */}
                                                    <input className='form-control'
                                                        value={'Nariman Point'}
                                                        disabled={true} />
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-sm-3 col-6">
                                                <div class="form-group mb_0">
                                                    <label>Venue</label>
                                                    <select
                                                        className={this.state.venueId != '' && this.state.venueId != 'Select' ? "form-control text-dark" : "form-control"}
                                                        style={{ width: "100%" }}
                                                        disabled={JSON.parse(sessionStorage.getItem('Is_modify')) == true}
                                                        value={venueId}
                                                        onChange={e => this.setState({ venueId: e.target.value })}
                                                    >
                                                        <option value={''}>Select</option>
                                                        {venueList.length > 0 ? venueList.map(data => (
                                                            <option
                                                                key={data.CenterID}
                                                                value={data.CenterID}>
                                                                {data.Name}
                                                            </option>
                                                        )) : <></>}
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-sm-3 col-6">
                                                <div style={{ zIndex: '2' }} class="form-group mb_0">
                                                    <label>Booking Date</label>
                                                    <div style={{ zIndex: '99' }} className="form-group d-flex" >
                                                        {/* <input type="text" class="form-control date" placeholder="Pick the multiple dates"/> */}
                                                        <DatePicker className={this.state.bookingDate != '' ? "form-control text-dark" : "form-control"}
                                                            // dateFormat="dd-MM-yyyy"
                                                            // disabled={statusId != 2 && is_update == true ? true : false}
                                                            // selected={this.state.toDate}
                                                            // minDate={this.state.fromDate == '' || this.state.fromDate == null ? this.state.minDate : this.state.fromDate}
                                                            // onChange={(date) => {
                                                            //     this.setState({ toDate: date });

                                                            // }}
                                                            dateFormat="dd-MM-yyyy"
                                                            // disabled={statusId != 2 && is_update == true ? true : false}
                                                            selected={bookingDate}
                                                            onChange={(date) => {
                                                                this.setState({ bookingDate: date })
                                                            }}
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            placeholderText="From Date"
                                                        // customInput={<ExampleCustomInput />}
                                                        // dayClassName={() => "example-datepicker-day-class"}
                                                        // popperClassName="example-datepicker-class"
                                                        />
                                                        {/* <DatePicker className="form-control date"

                                                            dateFormat="dd-MM-yyyy"
                                                            // disabled={statusId != 2 && is_update == true ? true : false}
                                                            selected={bookingDate}
                                                            onChange={(date) => {
                                                                this.setState({ bookingDate: date })
                                                            }}
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            dropdownMode="select"
                                                            placeholderText="Booking Date"
                                                        // customInput={<ExampleCustomInput />}
                                                        // dayClassName={() => "example-datepicker-day-class"}
                                                        // popperClassName="example-datepicker-class"
                                                        /> */}
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-md-2 col-sm-3 col-6">
                                                <div style={{ zIndex: '5' }} class="form-group mb_0">
                                                    <label>Timeslot</label>
                                                    <Select
                                                        isMulti
                                                        value={timeSlot}
                                                        styles={customStyles}
                                                        onChange={e => this.setState({ timeSlot: e })}
                                                        options={timeSlotList} />
                                                    {/* <select
                                                        isMulti
                                                        className={"form-control"}
                                                        style={{ width: "100%" }}
                                                        // disabled={true}
                                                        value={timeSlot}
                                                        onChange={e => this.setState({ timeSlot: e.target.value })}
                                                    >
                                                        <option>Select</option>
                                                        {timeSlotList.length > 0 ? timeSlotList.map(data => (
                                                            <option
                                                                key={data.TimeSlotID}
                                                                value={data.TimeSlotID}>
                                                                {data.FromTime} - {data.ToTime}
                                                            </option>
                                                        )) : <></>}
                                                    </select> */}
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-12 col-12">
                                                <div className='search_btn_css'>
                                                    <label>&nbsp;</label>
                                                    <a onClick={this.updateSearch} class="btn btn-primary custom_btn">Update Search</a>
                                                    <a onClick={this.clearSearch} class="btn btn-primary custom_btn ml-2">Clear Search</a>
                                                    {/* <label>&nbsp;</label> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section>
                            <div class=" container-fluid">
                                <div className='row mr-3 ml-3'>
                                    {/* <OwlCarousel style={{ zIndex: '1' }} items={5}
                                        loop
                                        nav
                                        margin={20}>
                                        <div class="item">
                                            <div class="">
                                                <div class="next_slots">
                                                    <h6><i class="fa fa-archive"></i> Facility 3</h6>
                                                    <p><i class="fa fa-map-marker"></i> BKC, Bandra West</p>
                                                    <p>Avl - Jul 10, 12, 13, 14</p>
                                                    <div class="img_div"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="">
                                                <div class="next_slots light_blue_hover">
                                                    <h6><i class="fa fa-archive"></i> Facility 4</h6>
                                                    <p><i class="fa fa-map-marker"></i> Worli, Mumbai</p>
                                                    <p>Avl - Jul 10, 12, 13, 14</p>
                                                    <div class="img_div"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="">
                                                <div class="next_slots light_green_hover">
                                                    <h6><i class="fa fa-archive"></i> Sanskriti Kendra I</h6>
                                                    <p><i class="fa fa-map-marker"></i> Nariman Point, Mumbai</p>
                                                    <p>Avl - Jul 13, 14, 15, 16</p>
                                                    <div class="img_div"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="">
                                                <div class="next_slots light_purple_hover">
                                                    <h6><i class="fa fa-archive"></i> Sanskriti Kendra II</h6>
                                                    <p> <i class="fa fa-map-marker"></i> BKC, Bandra West</p>
                                                    <p>Avl - Jul 10, 12, 13, 14</p>
                                                    <div class="img_div"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="">
                                                <div class="next_slots light_orange_hover">
                                                    <h6>Swastika</h6>
                                                    <p><i class="fa fa-map-marker"></i> Nariman Point, Mumbai</p>
                                                    <p>Avl - Jul 18, 19, 20, 21</p>
                                                    <div class="img_div"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="">
                                                <div class="next_slots light_orange_hover">
                                                    <h6>Swastika1</h6>
                                                    <p><i class="fa fa-map-marker"></i> Nariman Point, Mumbai</p>
                                                    <p>Avl - Jul 18, 19, 20, 21</p>
                                                    <div class="img_div"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="">
                                                <div class="next_slots light_orange_hover">
                                                    <h6>Swastika2</h6>
                                                    <p><i class="fa fa-map-marker"></i> Nariman Point, Mumbai</p>
                                                    <p>Avl - Jul 18, 19, 20, 21</p>
                                                    <div class="img_div"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="">
                                                <div class="next_slots light_orange_hover">
                                                    <h6>Swastika3</h6>
                                                    <p><i class="fa fa-map-marker"></i> Nariman Point, Mumbai</p>
                                                    <p>Avl - Jul 18, 19, 20, 21</p>
                                                    <div class="img_div"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="">
                                                <div class="next_slots light_orange_hover">
                                                    <h6>Swastika4</h6>
                                                    <p><i class="fa fa-map-marker"></i> Nariman Point, Mumbai</p>
                                                    <p>Avl - Jul 18, 19, 20, 21</p>
                                                    <div class="img_div"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </OwlCarousel> */}
                                </div>
                            </div>
                        </section>

                        <section id="availability" class="availability">
                            <div class="container-fluid">
                                <div class="">
                                    <div class="" style={{ background: "#fafafa" }}>
                                        <div class="row">
                                            <div class="col-md-12 text-right">
                                                <div class="indications_labels">
                                                    <div class="label grey"><i class="fa fa-circle"></i> Booked</div>
                                                    <div class="label black"><i class="fa fa-circle"></i> Blocked</div>
                                                    <div class="label green"><i class="fa fa-circle"></i> Available</div>
                                                    <button onClick={this.clearSelected} type="button" class="clear_button" data-toggle="tooltip" data-placement="left" title="This will clear all the Selected Booking Dates">
                                                        clear
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ overflow: 'auto', position: 'relative', zIndex: '0' }}>
                                            {this.state.finalDateList.length > 0 ?
                                                <table class=" table table-bordered table-sm my_table table-striped">
                                                    <thead className='fixedheader'>
                                                        <a onClick={this.prevWeek} className='leftArrow'><i class="fa fa-chevron-circle-left"></i></a>
                                                        <a onClick={this.nextWeek} className='rightArrow'><i class="fa fa-chevron-circle-right"></i></a>

                                                        <tr>
                                                            <th></th>
                                                            {this.state.finalDateList.map((data) => (
                                                                <th>
                                                                    <h6>{data.day}</h6>
                                                                    <p>{data.date}</p>
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.finalList.map((data) => (
                                                                <tr key={data.centerID}>
                                                                    <td>
                                                                        <h6>{data.centerName}</h6>
                                                                        <a>{selectedCenter == '' ? <>
                                                                            <div disabled={true} style={{ cursor: 'pointer' }} onClick={() => this.openCalenderView(data)} class="ribbon_css">Calendar View</div>
                                                                        </> : <>
                                                                            <div disabled={true} style={{ cursor: 'pointer' }} onClick={() => selectedCenter == data.centerID ? this.openCalenderView(data.centerID) : null} class="ribbon_css">Calendar View</div>
                                                                        </>
                                                                        }
                                                                        </a>
                                                                        <a href={data.url} target='blank' class="more_details">
                                                                            <div class="ribbon_css view_more_label">More Details...</div>
                                                                        </a>
                                                                    </td>
                                                                    {
                                                                        data.days.map((days) => (
                                                                            <td className={days.ISITMEClient == 1 && 'block_client'} key={days.day}>
                                                                                {!holidayArr.includes(days.day) ? <>
                                                                                    {(data.isSaturdayOff && days.dayName == "Saturday") || (data.isSundayOff && days.dayName == "Sunday") ? <label class="table_labels selected_color table_content_bg">MAINTENANCE DAY</label> :
                                                                                        //     <> {this.renderSlots(data, days)}</>}
                                                                                        // {(data.isSundayOff && days.dayName == "Sunday") ? <label class="table_labels selected_color table_content_bg">MAINTENANCE DAY</label> :
                                                                                        //     <>{this.renderSlots(data, days)}</>
                                                                                        <>{this.renderSlots(data, days)}</>}
                                                                                </>
                                                                                    : <label class="table_labels selected_color table_content_bg">MAINTENANCE DAY</label>}
                                                                            </td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table> :
                                                <table class=" table table-bordered table-sm my_table table-striped">
                                                    <thead className='fixedheader'>
                                                        <a onClick={this.prevWeek} style={{ zIndex: '99', position: "absolute", left: "150px", fontSize: "23px", color: '#828282' }}><i class="fa fa-chevron-circle-left"></i></a>
                                                        <a onClick={this.nextWeek} style={{ zIndex: '99', position: "absolute", right: "23px", fontSize: "23px", color: '#828282' }}><i class="fa fa-chevron-circle-right"></i></a>

                                                        <tr style={{ height: '35px' }}>
                                                            <th></th>
                                                            {this.state.finalDateList.map((data) => (
                                                                <th>
                                                                    <h6>{data.day}</h6>
                                                                    <p>{data.date}</p>
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tr><td colSpan={12} className='text-center'>Record not found</td></tr>
                                                </table>}
                                        </div>
                                        <div class="row  mr_0 ">
                                            <div class="col-md-12 padding_0 text-right">
                                                {sessionStorage.getItem('blockAccess') == 1 && <button disabled={bookingList.length == 0 || JSON.parse(sessionStorage.getItem('Is_modify')) == true} onClick={this.toggleModal} class="btn btn-warning custom_btn mr-2"><a style={{ color: 'white' }}>Block Calendar</a></button>}
                                                <button disabled={bookingList.length == 0} onClick={this.onBook} class="btn btn-primary custom_btn"><a>Book Now</a></button>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                    <Modal show={isOpen} onHide={this.toggleModal}>
                        <Modal.Header>
                            <Modal.Title><h4 class="modal-title modal_title_text">Add Client</h4></Modal.Title>
                            <button type="button " class="close pop-close" data-dismiss="modal" onClick={this.toggleModal} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                        </Modal.Header>
                        <Modal.Body>
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for="inputZip">Client</label>
                                    <div class="outside_input_field">
                                        {
                                            <input
                                                type="text"
                                                className="form-control"

                                                value={this.state.clientName}
                                                onChange={e => this.onClientSearch(e)}
                                                onInput={toInputUppercase}
                                            // onChange={this.changeUrl}
                                            />
                                        }
                                        {this.state.isDisplayClientList && this.renderClientList()}
                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{pinCodeErr}</span>} */}
                                        {/* <select
                                            className={"form-control"}
                                            style={{ width: "100%" }}
                                            // disabled={true}
                                            value={clientID}
                                            onChange={(e) => this.onClientSelect(e.target.value)}
                                        >
                                            <option>Select</option>
                                            {clientList.length > 0 ? clientList.map(data => (
                                                <option
                                                    key={data.ClientID}
                                                    value={data.ClientID}
                                                >
                                                    {data.Client}
                                                </option>
                                            )) : <></>}
                                        </select> */}
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div class="row">
                                <div class="col-md-12">
                                    <a onClick={this.handleBlockCalender} class="btn save_btn">Apply</a>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={isOpen2} onHide={this.toggleModal2}>
                        <Modal.Header>
                            {/* <Modal.Title><h4 class="">Note</h4></Modal.Title> */}
                        </Modal.Header>
                        <Modal.Body>
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <p>Date selection with a difference of more than a day at one time not allowed. In case of time spaced  multiple days session, you will have to fill different booking form.</p>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div class="row">
                                <div class="col-md-12">
                                    <a onClick={this.toggleModal2} class="btn save_btn">OK</a>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </>
                {/* <Footerlogin /> */}
            </>
        );

    }


}

export default withRouter(connect(null, { search_calender_action, fill_action, block_calender_action })(NormalView));
